import { Button, Drawer, Form, Space } from "antd";
import type { FormInstance } from "antd";
import { useEffect } from "react";

export type CrudDrawerProps<T> = {
  open: boolean;
  title: string;
  initialValues?: Partial<T>;
  loading?: boolean;
  onClose: () => void;
  onSubmit: (values: T) => Promise<unknown> | unknown;
  width?: number;
  children: (form: FormInstance<T>) => React.ReactNode;
};

export function CrudDrawer<T extends Record<string, unknown>>(props: CrudDrawerProps<T>) {
  const [form] = Form.useForm<T>();

  useEffect(() => {
    if (props.open) {
      form.resetFields();
      if (props.initialValues) {
        // setFieldsValue expects RecursivePartial<T>; Partial<T> is compatible at runtime.
        form.setFieldsValue(props.initialValues as Parameters<typeof form.setFieldsValue>[0]);
      }
    }
  }, [props.open, props.initialValues, form]);

  return (
    <Drawer
      open={props.open}
      title={props.title}
      width={props.width ?? 520}
      onClose={props.onClose}
      destroyOnClose
      extra={
        <Space>
          <Button onClick={props.onClose}>取消</Button>
          <Button
            type="primary"
            loading={props.loading}
            onClick={async () => {
              const values = await form.validateFields();
              await props.onSubmit(values);
            }}
          >
            保存
          </Button>
        </Space>
      }
    >
      <Form<T> layout="vertical" form={form}>
        {props.children(form)}
      </Form>
    </Drawer>
  );
}
